// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2189":"fa546949f8a6f30e","2888":"c8a828ae595d7a6b"}[chunkId] + ".css";
};